import styled from "styled-components";
import { Label } from "./Typography";

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  width: 100%;
`;

const StyledInput = styled.input`
  width: 100%;
  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(2)}`};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radii.control};
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  line-height: ${({ theme }) => theme.typography.lineHeights.body};
  transition:
    border-color ${({ theme }) => theme.transitions.default},
    outline ${({ theme }) => theme.transitions.default};

  &::placeholder {
    color: ${({ theme }) => theme.colors.textMuted};
  }

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.colors.borderStrong};
  }

  &:focus {
    outline: 1px solid ${({ theme }) => theme.colors.accent};
    outline-offset: 0;
    border-color: ${({ theme }) => theme.colors.accent};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

function Input({ label, id, ...props }) {
  const inputId = id || (label ? label.replace(/\s+/g, "-").toLowerCase() : undefined);

  if (label) {
    return (
      <Field>
        <Label htmlFor={inputId}>{label}</Label>
        <StyledInput id={inputId} {...props} />
      </Field>
    );
  }

  return <StyledInput id={inputId} {...props} />;
}

export default Input;
export { StyledInput };
